import { render, staticRenderFns } from "./repeat.vue?vue&type=template&id=37a1ca68&scoped=true"
import script from "./repeat.vue?vue&type=script&lang=js"
export * from "./repeat.vue?vue&type=script&lang=js"
import style0 from "./repeat.vue?vue&type=style&index=0&id=37a1ca68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1ca68",
  null
  
)

export default component.exports